import L from 'leaflet';
import ICON from '../../assets/icons/map_marker.svg';

const MapViewMarker = new L.Icon({
  iconUrl: ICON,
  iconRetinaUrl: ICON,
  iconAnchor: [13.5, 41],
  popupAnchor: [0, -40],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: new L.Point(27, 41),
});

export default MapViewMarker;
